import { Modal, Typography } from 'antd'
import { useSelector } from 'react-redux';
import { UpdateForm } from './UpdateForm.component';
import { AddForm } from './AddForm.component';
import { selectAllOrganizations } from '@store/organization';

interface Props {
  visible: boolean;
  onCancel: () => void;
}

export const AddUpdateForm = ({ visible, onCancel }: Props) => {
  const { selectedOrganization } = useSelector(selectAllOrganizations);

  return (
    <Modal
      className='users-actions_modal'
      title={(
        <Typography.Text className='flex justify-center text-base font-bold'>
          {`${selectedOrganization ? `Edit - ${selectedOrganization.title}` : 'Add new organization'}`}
        </Typography.Text>
      )}
      centered
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={800}
    >
      {selectedOrganization?.id
        ? <UpdateForm onCancel={onCancel} />
        : <AddForm onCancel={onCancel} />}
    </Modal>
  )
}